// TransitionModalContent.tsx
import React from "react";
import classes from "./TransitionModalContent.module.scss";
import { Input } from "../input/Input";
import Button from "../button/Button";
import { useTransitionModalContent } from "./useTransitionModalContent";

type Props = {
  orderId: number;
  onClose: () => void;
};

export const TransitionModalContent = ({ orderId, onClose }: Props) => {
  const {
    minutes,
    loading,
    presets,
    handlePreset,
    handleChange,
    handleSubmit,
    disabled,
  } = useTransitionModalContent(orderId, onClose);

  return (
    <div className={classes.container}>
      <div className={classes.title}>Запустить цепочку статусов</div>

      <div className={classes.presets}>
        {presets.map((preset) => (
          <button
            key={preset}
            className={`${classes.presetButton} ${String(preset) === minutes ? classes.active : ""}`}
            onClick={() => handlePreset(preset)}
          >
            {preset} мин
          </button>
        ))}
      </div>

      <Input
        type="text"
        fieldName="minutes"
        value={minutes}
        placeholder="Своё время в минутах"
        onChange={(value) => handleChange(String(value))}
      />

      <div className={classes.actions}>
        <Button
          title="Запустить"
          onClick={handleSubmit}
          disabled={disabled || loading}
          loading={loading}
          fullWidth
        />
        <Button
          title="Отмена"
          onClick={onClose}
          variant="outline"
          size="small"
        />
      </div>
    </div>
  );
};
